module.exports = __webpack_public_path__ + "fonts/MyriadPro-LightCond.685b92a.ttf";